import { OPTION_ROW_BASE_CLASS_NAME } from "@/components/ui/optionRow";
import { cn } from "@paribus/shared-ui";
import * as SelectPrimitive from "@radix-ui/react-select";
import { ChevronDown } from "lucide-react";
import React from "react";

import type { SelectOption } from "./types";

export interface SelectViewProps {
  value: string;
  options: SelectOption[];
  id?: string;
  disabled: boolean;
  className?: string;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  ariaInvalid?: boolean;
  onValueChange: (nextValue: string) => void;
}

const optionClassName = `${OPTION_ROW_BASE_CLASS_NAME} data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground`;

export const SelectView = ({
  value,
  options,
  id,
  disabled,
  className,
  ariaLabel,
  ariaDescribedBy,
  ariaInvalid,
  onValueChange,
}: SelectViewProps) => (
  <SelectPrimitive.Root value={value} onValueChange={onValueChange} disabled={disabled}>
    <SelectPrimitive.Trigger
      id={id}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid}
      className={cn(
        "flex items-center justify-between gap-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
    >
      <SelectPrimitive.Value className="flex-1 truncate text-left" />
      <SelectPrimitive.Icon asChild>
        <ChevronDown size={14} className="shrink-0 opacity-50" />
      </SelectPrimitive.Icon>
    </SelectPrimitive.Trigger>
    <SelectPrimitive.Portal>
      <SelectPrimitive.Content
        position="popper"
        sideOffset={4}
        className="z-popover max-h-[300px] w-[--radix-select-trigger-width] overflow-y-auto rounded-md border bg-popover p-1 text-popover-foreground shadow-md"
      >
        <SelectPrimitive.Viewport>
          {options.map((option) => (
            <SelectPrimitive.Item
              key={option.value}
              value={option.value}
              className={optionClassName}
            >
              <SelectPrimitive.ItemText>{option.label}</SelectPrimitive.ItemText>
            </SelectPrimitive.Item>
          ))}
        </SelectPrimitive.Viewport>
      </SelectPrimitive.Content>
    </SelectPrimitive.Portal>
  </SelectPrimitive.Root>
);
